export const FormatsData: {[k: string]: ModdedSpeciesFormatsData} = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "PU",
	},
	venusaur: {
		tier: "UUBL",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "PU",
	},
	charizard: {
		tier: "OU",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "ZU",
	},
	blastoise: {
		tier: "UU",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		tier: "ZU",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		tier: "ZU",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "ZU",
	},
	pidgeot: {
		tier: "NU",
	},
	rattata: {
		tier: "LC",
	},
	raticate: {
		tier: "NU",
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		tier: "UU",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		tier: "PU",
	},
	pichu: {
		tier: "LC",
	},
	pikachu: {
		tier: "NU",
	},
	raichu: {
		tier: "UU",
	},
	sandshrew: {
		tier: "LC",
	},
	sandslash: {
		tier: "UU",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		tier: "UU",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "ZU",
	},
	nidoking: {
		tier: "UU",
	},
	cleffa: {
		tier: "LC",
	},
	clefairy: {
		tier: "NFE",
	},
	clefable: {
		tier: "UU",
	},
	vulpix: {
		tier: "LC",
	},
	ninetales: {
		tier: "UU",
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		tier: "PU",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "NU",
	},
	crobat: {
		tier: "UUBL",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "ZU",
	},
	vileplume: {
		tier: "UU",
	},
	bellossom: {
		tier: "NU",
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		tier: "ZU",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		tier: "NU",
	},
	diglett: {
		tier: "NU",
	},
	dugtrio: {
		tier: "OU",
	},
	meowth: {
		tier: "LC",
	},
	persian: {
		tier: "UU",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		tier: "UU",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		tier: "UU",
	},
	growlithe: {
		tier: "ZU",
	},
	arcanine: {
		tier: "UU",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "ZUBL",
	},
	poliwrath: {
		tier: "UU",
	},
	politoed: {
		tier: "UU",
	},
	abra: {
		tier: "PU",
	},
	kadabra: {
		tier: "UUBL",
	},
	alakazam: {
		tier: "UUBL",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "PUBL",
	},
	machamp: {
		tier: "UUBL",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "ZU",
	},
	victreebel: {
		tier: "UU",
	},
	tentacool: {
		tier: "ZU",
	},
	tentacruel: {
		tier: "UU",
	},
	geodude: {
		tier: "LC",
	},
	graveler: {
		tier: "ZU",
	},
	golem: {
		tier: "UU",
	},
	ponyta: {
		tier: "ZU",
	},
	rapidash: {
		tier: "UU",
	},
	slowpoke: {
		tier: "LC",
	},
	slowbro: {
		tier: "UUBL",
	},
	slowking: {
		tier: "UU",
	},
	magnemite: {
		tier: "ZU",
	},
	magneton: {
		tier: "OU",
	},
	farfetchd: {
		tier: "ZU",
	},
	doduo: {
		tier: "ZU",
	},
	dodrio: {
		tier: "UUBL",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		tier: "NU",
	},
	grimer: {
		tier: "ZU",
	},
	muk: {
		tier: "UU",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		tier: "OU",
	},
	gastly: {
		tier: "PU",
	},
	haunter: {
		tier: "NU",
	},
	gengar: {
		tier: "OU",
	},
	onix: {
		tier: "LC",
	},
	steelix: {
		tier: "UUBL",
	},
	drowzee: {
		tier: "ZU",
	},
	hypno: {
		tier: "UU",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		tier: "PU",
	},
	voltorb: {
		tier: "ZU",
	},
	electrode: {
		tier: "UU",
	},
	exeggcute: {
		tier: "ZU",
	},
	exeggutor: {
		tier: "UUBL",
	},
	cubone: {
		tier: "ZU",
	},
	marowak: {
		tier: "UUBL",
	},
	tyrogue: {
		tier: "LC",
	},
	hitmonlee: {
		tier: "UU",
	},
	hitmonchan: {
		tier: "NU",
	},
	hitmontop: {
		tier: "UU",
	},
	lickitung: {
		tier: "PU",
	},
	koffing: {
		tier: "ZU",
	},
	weezing: {
		tier: "UUBL",
	},
	rhyhorn: {
		tier: "ZU",
	},
	rhydon: {
		tier: "UUBL",
	},
	chansey: {
		tier: "UUBL",
	},
	blissey: {
		tier: "OU",
	},
	tangela: {
		tier: "PU",
	},
	kangaskhan: {
		tier: "UU",
	},
	horsea: {
		tier: "ZU",
	},
	seadra: {
		tier: "PU",
	},
	kingdra: {
		tier: "UUBL",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		tier: "ZU",
	},
	staryu: {
		tier: "ZU",
	},
	starmie: {
		tier: "OU",
	},
	mrmime: {
		tier: "UU",
	},
	scyther: {
		tier: "UU",
	},
	scizor: {
		tier: "UUBL",
	},
	smoochum: {
		tier: "ZU",
	},
	jynx: {
		tier: "UUBL",
	},
	elekid: {
		tier: "ZU",
	},
	electabuzz: {
		tier: "UU",
	},
	magby: {
		tier: "ZU",
	},
	magmar: {
		tier: "UU",
	},
	pinsir: {
		tier: "UU",
	},
	tauros: {
		tier: "UUBL",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		tier: "OU",
	},
	lapras: {
		tier: "UU",
	},
	ditto: {
		tier: "ZU",
	},
	eevee: {
		tier: "LC",
	},
	vaporeon: {
		tier: "UUBL",
	},
	jolteon: {
		tier: "OU",
	},
	flareon: {
		tier: "NU",
	},
	espeon: {
		tier: "UUBL",
	},
	umbreon: {
		tier: "UUBL",
	},
	porygon: {
		tier: "ZU",
	},
	porygon2: {
		tier: "UUBL",
	},
	omanyte: {
		tier: "PU",
	},
	omastar: {
		tier: "UU",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		tier: "UU",
	},
	aerodactyl: {
		tier: "OU",
	},
	snorlax: {
		tier: "OU",
	},
	articuno: {
		tier: "UUBL",
	},
	zapdos: {
		tier: "OU",
	},
	moltres: {
		tier: "OU",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "PU",
	},
	dragonite: {
		tier: "UUBL",
	},
	mewtwo: {
		tier: "Uber",
	},
	mew: {
		tier: "Uber",
	},
	chikorita: {
		tier: "LC",
	},
	bayleef: {
		tier: "ZU",
	},
	meganium: {
		tier: "UU",
	},
	cyndaquil: {
		tier: "ZU",
	},
	quilava: {
		tier: "ZU",
	},
	typhlosion: {
		tier: "UUBL",
	},
	totodile: {
		tier: "LC",
	},
	croconaw: {
		tier: "ZU",
	},
	feraligatr: {
		tier: "UU",
	},
	sentret: {
		tier: "LC",
	},
	furret: {
		tier: "PU",
	},
	hoothoot: {
		tier: "LC",
	},
	noctowl: {
		tier: "ZU",
	},
	ledyba: {
		tier: "LC",
	},
	ledian: {
		tier: "ZU",
	},
	spinarak: {
		tier: "LC",
	},
	ariados: {
		tier: "ZU",
	},
	chinchou: {
		tier: "PU",
	},
	lanturn: {
		tier: "UU",
	},
	togepi: {
		tier: "LC",
	},
	togetic: {
		tier: "PU",
	},
	natu: {
		tier: "LC",
	},
	xatu: {
		tier: "UU",
	},
	mareep: {
		tier: "LC",
	},
	flaaffy: {
		tier: "ZU",
	},
	ampharos: {
		tier: "UU",
	},
	azurill: {
		tier: "LC",
	},
	marill: {
		tier: "NFE",
	},
	azumarill: {
		tier: "UU",
	},
	sudowoodo: {
		tier: "NU",
	},
	hoppip: {
		tier: "LC",
	},
	skiploom: {
		tier: "NFE",
	},
	jumpluff: {
		tier: "UU",
	},
	aipom: {
		tier: "ZU",
	},
	sunkern: {
		tier: "LC",
	},
	sunflora: {
		tier: "ZU",
	},
	yanma: {
		tier: "PU",
	},
	wooper: {
		tier: "LC",
	},
	quagsire: {
		tier: "UU",
	},
	murkrow: {
		tier: "NU",
	},
	misdreavus: {
		tier: "UU",
	},
	unown: {
		tier: "ZU",
	},
	wynaut: {
		tier: "Uber",
	},
	wobbuffet: {
		tier: "Uber",
	},
	girafarig: {
		tier: "UU",
	},
	pineco: {
		tier: "LC",
	},
	forretress: {
		tier: "OU",
	},
	dunsparce: {
		tier: "PUBL",
	},
	gligar: {
		tier: "UU",
	},
	snubbull: {
		tier: "LC",
	},
	granbull: {
		tier: "UU",
	},
	qwilfish: {
		tier: "UU",
	},
	shuckle: {
		tier: "PU",
	},
	heracross: {
		tier: "OU",
	},
	sneasel: {
		tier: "UU",
	},
	teddiursa: {
		tier: "LC",
	},
	ursaring: {
		tier: "UUBL",
	},
	slugma: {
		tier: "LC",
	},
	magcargo: {
		tier: "PU",
	},
	swinub: {
		tier: "LC",
	},
	piloswine: {
		tier: "PUBL",
	},
	corsola: {
		tier: "ZUBL",
	},
	remoraid: {
		tier: "LC",
	},
	octillery: {
		tier: "NU",
	},
	delibird: {
		tier: "ZU",
	},
	mantine: {
		tier: "UU",
	},
	skarmory: {
		tier: "OU",
	},
	houndour: {
		tier: "PU",
	},
	houndoom: {
		tier: "UUBL",
	},
	phanpy: {
		tier: "LC",
	},
	donphan: {
		tier: "UUBL",
	},
	stantler: {
		tier: "UU",
	},
	smeargle: {
		tier: "UUBL",
	},
	miltank: {
		tier: "UUBL",
	},
	raikou: {
		tier: "UUBL",
	},
	entei: {
		tier: "UUBL",
	},
	suicune: {
		tier: "OU",
	},
	larvitar: {
		tier: "LC",
	},
	pupitar: {
		tier: "NU",
	},
	tyranitar: {
		tier: "OU",
	},
	lugia: {
		tier: "Uber",
	},
	hooh: {
		tier: "Uber",
	},
	celebi: {
		tier: "OU",
	},
	treecko: {
		tier: "LC",
	},
	grovyle: {
		tier: "PU",
	},
	sceptile: {
		tier: "UUBL",
	},
	torchic: {
		tier: "LC",
	},
	combusken: {
		tier: "PU",
	},
	blaziken: {
		tier: "UUBL",
	},
	mudkip: {
		tier: "LC",
	},
	marshtomp: {
		tier: "PU",
	},
	swampert: {
		tier: "OU",
	},
	poochyena: {
		tier: "LC",
	},
	mightyena: {
		tier: "PU",
	},
	zigzagoon: {
		tier: "NFE",
	},
	linoone: {
		tier: "UUBL",
	},
	wurmple: {
		tier: "LC",
	},
	silcoon: {
		tier: "NFE",
	},
	beautifly: {
		tier: "ZU",
	},
	cascoon: {
		tier: "NFE",
	},
	dustox: {
		tier: "ZU",
	},
	lotad: {
		tier: "LC",
	},
	lombre: {
		tier: "ZU",
	},
	ludicolo: {
		tier: "UUBL",
	},
	seedot: {
		tier: "LC",
	},
	nuzleaf: {
		tier: "NFE",
	},
	shiftry: {
		tier: "UU",
	},
	taillow: {
		tier: "ZU",
	},
	swellow: {
		tier: "UUBL",
	},
	wingull: {
		tier: "LC",
	},
	pelipper: {
		tier: "NU",
	},
	ralts: {
		tier: "LC",
	},
	kirlia: {
		tier: "NFE",
	},
	gardevoir: {
		tier: "UUBL",
	},
	surskit: {
		tier: "LC",
	},
	masquerain: {
		tier: "ZU",
	},
	shroomish: {
		tier: "LC",
	},
	breloom: {
		tier: "OU",
	},
	slakoth: {
		tier: "LC",
	},
	vigoroth: {
		tier: "NU",
	},
	slaking: {
		tier: "UUBL",
	},
	nincada: {
		tier: "LC",
	},
	ninjask: {
		tier: "UU",
	},
	shedinja: {
		tier: "ZUBL",
	},
	whismur: {
		tier: "LC",
	},
	loudred: {
		tier: "NFE",
	},
	exploud: {
		tier: "UU",
	},
	makuhita: {
		tier: "LC",
	},
	hariyama: {
		tier: "UUBL",
	},
	nosepass: {
		tier: "ZU",
	},
	skitty: {
		tier: "LC",
	},
	delcatty: {
		tier: "ZU",
	},
	sableye: {
		tier: "NU",
	},
	mawile: {
		tier: "PU",
	},
	aron: {
		tier: "ZU",
	},
	lairon: {
		tier: "ZUBL",
	},
	aggron: {
		tier: "UU",
	},
	meditite: {
		tier: "ZU",
	},
	medicham: {
		tier: "UUBL",
	},
	electrike: {
		tier: "LC",
	},
	manectric: {
		tier: "UU",
	},
	plusle: {
		tier: "NU",
	},
	minun: {
		tier: "PU",
	},
	volbeat: {
		tier: "ZU",
	},
	illumise: {
		tier: "ZU",
	},
	roselia: {
		tier: "NU",
	},
	gulpin: {
		tier: "LC",
	},
	swalot: {
		tier: "PU",
	},
	carvanha: {
		tier: "LC",
	},
	sharpedo: {
		tier: "UU",
	},
	wailmer: {
		tier: "LC",
	},
	wailord: {
		tier: "NU",
	},
	numel: {
		tier: "LC",
	},
	camerupt: {
		tier: "UU",
	},
	torkoal: {
		tier: "NU",
	},
	spoink: {
		tier: "ZU",
	},
	grumpig: {
		tier: "UU",
	},
	spinda: {
		tier: "ZU",
	},
	trapinch: {
		tier: "PU",
	},
	vibrava: {
		tier: "PU",
	},
	flygon: {
		tier: "OU",
	},
	cacnea: {
		tier: "LC",
	},
	cacturne: {
		tier: "NU",
	},
	swablu: {
		tier: "LC",
	},
	altaria: {
		tier: "UU",
	},
	zangoose: {
		tier: "UUBL",
	},
	seviper: {
		tier: "PU",
	},
	lunatone: {
		tier: "UU",
	},
	solrock: {
		tier: "UU",
	},
	barboach: {
		tier: "LC",
	},
	whiscash: {
		tier: "NU",
	},
	corphish: {
		tier: "LC",
	},
	crawdaunt: {
		tier: "NU",
	},
	baltoy: {
		tier: "LC",
	},
	claydol: {
		tier: "OU",
	},
	lileep: {
		tier: "ZU",
	},
	cradily: {
		tier: "UU",
	},
	anorith: {
		tier: "ZU",
	},
	armaldo: {
		tier: "UUBL",
	},
	feebas: {
		tier: "LC",
	},
	milotic: {
		tier: "OU",
	},
	castform: {
		tier: "ZU",
	},
	castformsunny: {
		tier: "ZU",
	},
	castformrainy: {
		tier: "ZU",
	},
	castformsnowy: {
		tier: "ZU",
	},
	kecleon: {
		tier: "NU",
	},
	shuppet: {
		tier: "ZU",
	},
	banette: {
		tier: "UU",
	},
	duskull: {
		tier: "PU",
	},
	dusclops: {
		tier: "UUBL",
	},
	tropius: {
		tier: "PU",
	},
	chimecho: {
		tier: "NU",
	},
	absol: {
		tier: "UU",
	},
	snorunt: {
		tier: "ZU",
	},
	glalie: {
		tier: "NU",
	},
	spheal: {
		tier: "LC",
	},
	sealeo: {
		tier: "PU",
	},
	walrein: {
		tier: "UU",
	},
	clamperl: {
		tier: "ZU",
	},
	huntail: {
		tier: "NU",
	},
	gorebyss: {
		tier: "UU",
	},
	relicanth: {
		tier: "NU",
	},
	luvdisc: {
		tier: "ZU",
	},
	bagon: {
		tier: "LC",
	},
	shelgon: {
		tier: "PU",
	},
	salamence: {
		tier: "OU",
	},
	beldum: {
		tier: "LC",
	},
	metang: {
		tier: "NU",
	},
	metagross: {
		tier: "OU",
	},
	regirock: {
		tier: "UUBL",
	},
	regice: {
		tier: "UUBL",
	},
	registeel: {
		tier: "UUBL",
	},
	latias: {
		tier: "Uber",
	},
	latios: {
		tier: "Uber",
	},
	kyogre: {
		tier: "Uber",
	},
	groudon: {
		tier: "Uber",
	},
	rayquaza: {
		tier: "Uber",
	},
	jirachi: {
		tier: "OU",
	},
	deoxys: {
		tier: "Uber",
	},
	deoxysattack: {
		tier: "Uber",
	},
	deoxysdefense: {
		tier: "Uber",
	},
	deoxysspeed: {
		tier: "Uber",
	},
};
